import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { OrderLifetimeRuleAction } from '../orderLifetimeRule.action';

export const reloadOrderLifetimeRuleListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    OrderLifetimeRuleAction.reload,
    OrderLifetimeRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      OrderLifetimeRuleAction.loadList.started(),
    ];
  }),
);
